import { Brand } from '@/contexts/backoffice/library/models/resource'
import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface BrandAutocompleteProps {
  value: Brand | null
  handleInputChange: (field: string, value: any) => void
  props?: any
}

function BrandAutocomplete({ value, handleInputChange, props }: BrandAutocompleteProps) {
  const { t } = useTranslation(['global'])
  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const selectedBrand: Brand = userBrands.find((brand: Brand) => brand.id === value?.id) ?? null

  return (
    <Autocomplete
      id="autocomplete-brands"
      ChipProps={{ color: 'secondary' }}
      value={selectedBrand}
      onChange={(_, newValue) => {
        handleInputChange('brand', newValue ? newValue : null)
      }}
      options={userBrands}
      getOptionLabel={option => (option && typeof option === 'object' && option.name ? option.name : '')}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={params => (
        <TextField
          {...props}
          {...params}
          label={t('brands')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.brand}
          helperText={msgForm.brand}
        />
      )}
    />
  )
}

export default BrandAutocomplete
